import type { ProfileTranslations } from "../interfaces/profile";

export const profileTranslations: ProfileTranslations = {
  eyebrow: "Account",
  page_title: "My Profile",
  page_sub: "Your account information and contact details.",
  identity_title: "Your profile",
  identity_sub: "This information appears on receipts and in the history visible to your team.",
  contact_section_title: "Contact Information",
  account_section_title: "Account Details",
  email_label: "Email",
  phone_label: "Phone",
  country_label: "Country",
  language_label: "Language",
  status_label: "Status",
  two_factor_label: "Two-factor authentication",
  last_login_label: "Last login",
  two_factor_enabled: "Enabled",
  two_factor_disabled: "Disabled",
  not_specified: "Not specified",
};
